import React, { useEffect, useState } from 'react'
import { apiRequest } from '../../infrastructure/backendService';
import { CMS_BASE_URL } from '../../config/apiUrl';
import styles from "./hallContractForm.module.scss";
import FormSeven from './formSeven';
import { CommonButton, CommonOutlinedButton } from '../common/StyledComponents/StyledFields';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormFooter from './formFooter';

interface fromSixProps {
  updateParentState: (newState: boolean) => void
  formData: any;
  sign: string;
  handleInputChange: any
}

const FormSix = (props: fromSixProps) => {
  const [html, setHTML] = useState({ __html: '' });
  const [nextStep, setNextStep] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    apiRequest({
      method: "GET",
      basePath: `${CMS_BASE_URL}`,
      includeToken: false,
      endpoint: '/wp-json/wp/v2/hccc-page',
      params: {
        slug: "facility-usage-application-p6"
      }
    })
      .then((res) => {
        console.log(res);
        const acfContent = res.data[0]?.acf?.hccc_page || '';
        // const styledContent = acfContent.replace(
        //   /<p class="MuiTypography-root MuiTypography-body1 _headername_8c7n3_281 css-9l3uo3">/g,
        //   `<p class="${styles.headername}">`
        // );
        setHTML({ __html: acfContent });
      })
      .catch((err) => {
        console.log(err)
      })
  };

  const updatedState = (newState: boolean) => {
    setNextStep(newState);
  }

  const handleClick = () => {
    props.updateParentState(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const FormStepContent = () => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <span className={styles.currentNumberStyle}>6</span>{" "}
      <span className={styles.totalPagesNumberStyle}>/ 9</span>
    </div>
  );

  const navigationButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          startIcon={<ChevronLeftIcon />}
          onClick={handleClick}
        >
          Previous
        </CommonOutlinedButton>
        {FormStepContent()}
        <CommonButton
          endIcon={<KeyboardArrowRightIcon />}
          onClick={() => {
            setNextStep(true)
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          Next
        </CommonButton>
      </div>
    );
  };

  return (
    <div>
      {!nextStep && <div style={{ display: "flex", flexDirection: "column" }}>
        {/* <div style={{ display: "flex", gap: "1rem", float: "right", marginBottom: "40px", marginLeft: "auto" }}>
          {navigationButtons()}
        </div> */}
        <div dangerouslySetInnerHTML={html} />
        <FormFooter
          sign={props.sign}
          handleInputChange={props.handleInputChange}
          navigationButtons={navigationButtons()}
        />
      </div>}
      {nextStep && <FormSeven sign={props.sign} handleInputChange={props.handleInputChange} updateParentState={updatedState} formData={props.formData} />}
    </div>
  )
}

export default FormSix
